import { IBreadcrumb } from './BreadcrumbSeoScript';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface IFaqBreadcrumb {
    breadcrumb: IBreadcrumb[];
}

interface BreadcrumbElementProps {
    isLast: boolean;
    text: string;
    href?: string;
}

const BreadcrumbElement = ({ isLast, text, href }: BreadcrumbElementProps) =>
    isLast ? <Typography color="textPrimary">{text}</Typography> : <Link href={href}>{text}</Link>;

const HelpCenterBreadcrumbs = ({ breadcrumb }: IFaqBreadcrumb) => (
    <Breadcrumbs sx={{ pb: { xs: 3, md: 4 } }} aria-label="faq-breadcrumbs">
        {breadcrumb.map((crumb: IBreadcrumb, index: number) => (
            <BreadcrumbElement
                key={`breadcrumb-${index}`}
                isLast={index === breadcrumb.length - 1}
                text={crumb.name}
                href={crumb.url}
            />
        ))}
    </Breadcrumbs>
);

export default HelpCenterBreadcrumbs;
